import React from "react";
import * as palette from "@govlaunch/palette";
import { Field } from "react-final-form";
import FieldValidationError from "~/components/form/FieldValidationError";
import { IFormFieldProps } from "~/components/form/FormFieldProps";
import { Input } from "@govlaunch/core";

export default function NumberField({ label, fieldName, placeholder, ...props }: IFormFieldProps) {
  return (
    <Field name={fieldName} type="number">
      {({ input, meta }) => (
        <div>
          {label && (
            <div
              css={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                css={{
                  fontWeight: 500,
                  fontSize: 14,
                  color: palette.mediumGray,
                  margin: 0,
                }}
              >
                {label}
              </label>

              <FieldValidationError meta={meta} />
            </div>
          )}

          <Input
            css={{
              marginTop: label ? 8 : 0,
              height: 42,
              width: "100%",
              borderRadius: 6,
              outline: 0,
              border: `solid 1px ${palette.lightestGray}`,
              fontSize: 14,
              padding: "6px 12px",
              "::placeholder": {
                color: palette.sealBlue,
              },
              ":focus": {
                borderColor: palette.primary,
              },
            }}
            placeholder={placeholder}
            {...input}
            {...props}
          />
        </div>
      )}
    </Field>
  );
}
